import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText } from "@mui/material";

const ErrorsDialog = ({ open, handleClose, errors }) => {
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Error</DialogTitle>
            <DialogContent>
                <List sx={{ listStyleType: "disc", pl: 4 }}>
                    {errors && Array.isArray(errors) && errors.map((error, index) => (
                        <ListItem key={index} sx={{ display: "list-item" }}>
                            <ListItemText primary={error.message} />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorsDialog;
